import { render, staticRenderFns } from "./BudgetModal.vue?vue&type=template&id=1bd0ce23&"
import script from "./BudgetModal.vue?vue&type=script&lang=js&"
export * from "./BudgetModal.vue?vue&type=script&lang=js&"
import style0 from "./BudgetModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports